import { render, staticRenderFns } from "./NotificationTabs.vue?vue&type=template&id=bd5abb60&scoped=true"
import script from "./NotificationTabs.vue?vue&type=script&lang=js"
export * from "./NotificationTabs.vue?vue&type=script&lang=js"
import style0 from "./NotificationTabs.vue?vue&type=style&index=0&id=bd5abb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5abb60",
  null
  
)

export default component.exports